module.exports = __webpack_public_path__ + "img/monmi.92de3a4e.png";